import { render, staticRenderFns } from "./suporte-procedimentos.vue?vue&type=template&id=6797c3bb"
import script from "./suporte-procedimentos.vue?vue&type=script&lang=ts"
export * from "./suporte-procedimentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports